import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[appGhostButton]',
    standalone: false
})
export class GhostButtonDirective {
    @HostBinding('class') get classes(): string {
        return 'ghost-button-uniform';
    }
}
